const getters = {

  token: state => state.user.token,
  userId: state => state.user.userId,
  userName: state => state.user.userName,
  loginStatus: state => state.user.loginStatus,

}
export default getters
